import { Library } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { useMinCopy } from '@/i18n/useUiLocale'

interface ArticleGeneratedDialogProps {
  onStartReading: () => void
  onGoToLibrary: () => void
}

export function ArticleGeneratedDialog({
  onStartReading,
  onGoToLibrary,
}: ArticleGeneratedDialogProps) {
  const { reading } = useMinCopy()

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      data-testid="article-generated-dialog"
    >
      <div className="w-full max-w-sm rounded-xl border bg-card p-6 shadow-2xl">
        <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Library className="h-5 w-5" />
        </div>
        <h2 className="text-lg font-semibold">{reading.articleGeneratedTitle}</h2>
        <p className="mt-2 text-sm text-muted-foreground">{reading.articleGeneratedBody}</p>
        <div className="mt-5 flex flex-col gap-2 sm:flex-row">
          <Button className="flex-1" onClick={onStartReading} data-testid="article-generated-start">
            {reading.articleGeneratedStart}
          </Button>
          <Button
            className="flex-1 bg-secondary text-secondary-foreground hover:bg-secondary/80"
            onClick={onGoToLibrary}
            data-testid="article-generated-library"
          >
            {reading.articleGeneratedLibrary}
          </Button>
        </div>
      </div>
    </div>
  )
}
